import { render } from "./RecentlyBoughtProducts.vue?vue&type=template&id=bc3a7802"
import script from "./RecentlyBoughtProducts.vue?vue&type=script&lang=js"
export * from "./RecentlyBoughtProducts.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__